import UserAnswerList from '../components/userAnswer/List.vue';
import auth from '../middleware/auth';

export default [
    {
        name: 'UserAnswerList',
        path: '/my-answers',
        component: UserAnswerList,
        meta: {
            middleware: [auth],
            title: 'global.menu.questions.myAnswers'
        }
    },
    {
        name: 'UserAnswerSkippedList',
        path: '/my-answers/unanswered',
        component: UserAnswerList,
        props: {
            defaultFilters: {
                isSkipped: true
            }
        },
        meta: {
            middleware: [auth],
            title: 'global.menu.questions.myAnswers'
        }
    },
];


// WEBPACK FOOTER //
// ./src/routes/userAnswer.js